import { InjectionToken } from '@angular/core';
import { UserContext } from '../interfaces/user-context.interface';

export const USER_CONTEXT = new InjectionToken<UserContext>('USER_CONTEXT');
